import {
  ADD_BUTTON_TEXT_UNAVAILABLE_STRING,
  SOLD_OUT_VARIANT_VALUE_STRING,
  UNAVAILABLE_VARIANT_VALUE_STRING,
  PRODUCT_FORM_SELECTOR,
  PRICE_CONTAINER_SELECTOR,
  MEDIA_CONTAINER_SELECTOR,
  PICKUP_AVAILABILITY_SELECTOR
} from './const'
import {fetchHTML, shouldShowBISForVariant, updatePickupButtonsVisibility} from './helpers'

function updateDomAddButton(disable = true, text, modifyClass = true, loading = false) {
  try {
    const productForm = document.querySelector(PRODUCT_FORM_SELECTOR)
    if (!productForm) {
      console.warn('Product form not found')
      return
    }

    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')


    if (loading && addButton) {
      addButton.classList.add('loading')
    } else if (addButton) {
      addButton.classList.remove('loading')
    }

    if (!addButton) {
      console.warn('Add button not found')
      return
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text && addButtonText) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      if (addButtonText) addButtonText.textContent = ADD_BUTTON_TEXT_UNAVAILABLE_STRING
    }

    if (!modifyClass) return

    if (disable) {
      addButton.classList.add('disabled')
    } else {
      addButton.classList.remove('disabled')
    }
  } catch (error) {
    console.error('Error updating add button:', error)
  }
}

function updateVariantIdInput() {
  try {
    const productForms = document.querySelectorAll(PRODUCT_FORM_SELECTOR)
    if (!productForms.length) {
      console.warn('No product forms found')
      return
    }
    productForms.forEach((productForm) => {
      const input: HTMLInputElement = productForm.querySelector('input[name="id"]')
      if (!input) {
        console.warn('Variant ID input not found in form')
        return
      }
      if (!window.prodify.currentVariant?.id) {
        console.warn('No current variant ID available')
        return
      }
      input.value = window.prodify.currentVariant.id.toString()
    })
  } catch (error) {
    console.error('Error updating variant ID input:', error)
  }
}

function setInputAvailability(optionInputs, availableOptionInputValues, existingOptionInputsValues, optionIndex: number) {
  try {
    if (!optionInputs || !Array.isArray(optionInputs)) {
      console.warn('Invalid option inputs')
      return
    }

    optionInputs.forEach((input) => {
      if (!input) return

      const value = input.getAttribute('value')
      if (!value) {
        console.warn('Input has no value attribute')
        return
      }

      if (availableOptionInputValues.includes(value)) {
        if (window.prodify.pickerTypes[`option${optionIndex}`] === 'select') {
          input.innerText = value
          return
        }
        input.classList.remove('disabled')
      } else if (existingOptionInputsValues.includes(value)) {
        if (window.prodify.pickerTypes[`option${optionIndex}`] === 'select') {
          input.innerText = SOLD_OUT_VARIANT_VALUE_STRING.replace('[value]', value)
          return
        }
        input.classList.add('disabled')
      } else {
        if (window.prodify.pickerTypes[`option${optionIndex}`] === 'select') {
          input.innerText = UNAVAILABLE_VARIANT_VALUE_STRING.replace('[value]', value)
          return
        }
        input.classList.add('disabled')
      }
    })
  } catch (error) {
    console.error('Error setting input availability:', error)
  }
}

function maybeSetOptionSelected(select, optionIndex: number) {
  try {
    if (!select) {
      console.warn('No select element provided')
      return
    }

    if (window.prodify.pickerTypes[`option${optionIndex}`] === 'select') {
      const options = Array.from(select.querySelectorAll('option'))
      const currentValue = select.value

      options.forEach((option: HTMLOptionElement) => {
        if (option.value === currentValue) {
          option.setAttribute('selected', 'selected')
        } else {
          option.removeAttribute('selected')
        }
      })
    }
  } catch (error) {
    console.error('Error setting option selected:', error)
  }
}

function updateQuantity(stepDirection) {
  try {
    if (!window.prodify.quantityPresentationInput || !window.prodify.quantityHiddenInput) {
      console.warn('Quantity inputs not found')
      return
    }

    const previousQuantity = parseInt(window.prodify.quantityPresentationInput.value)
    const newQuantity = stepDirection === 'up' ? previousQuantity + 1 : Math.max(1, previousQuantity - 1)

    window.prodify.quantityHiddenInput.value = window.prodify.quantityPresentationInput.value = newQuantity.toString()
  } catch (error) {
    console.error('Error updating quantity:', error)
  }
}

function swapProductInfo() {
  try {
    if (!window.prodify.currentVariant?.id) {
      console.warn('No current variant ID available for product info swap')
      return
    }


    if (window.isSpanishMarket && window.spanishVariantImageMapping) {
      handleSpanishVariantChange(window.prodify.currentVariant)
    }

    fetchHTML(`${window.prodify.el.dataset.url}?variant=${window.prodify.currentVariant.id}&section_id=${window.prodify.el.dataset.section}`)
      .then((responseHTML) => {
        if (!responseHTML) {
          throw new Error('No response HTML received')
        }

        const priceSource = responseHTML.querySelector(PRICE_CONTAINER_SELECTOR)
        const priceTarget = window.prodify.el.querySelector(PRICE_CONTAINER_SELECTOR)
        const mediaSource = responseHTML.querySelector(MEDIA_CONTAINER_SELECTOR)
        const mediaTarget = window.prodify.el.querySelector(MEDIA_CONTAINER_SELECTOR)
        const addButtonSource = responseHTML.querySelector(`${PRODUCT_FORM_SELECTOR} [name="add"]`)
        const addButtonTarget = window.prodify.el.querySelector(`${PRODUCT_FORM_SELECTOR} [name="add"]`)
        const pickupAvailabilitySource = responseHTML.querySelector(PICKUP_AVAILABILITY_SELECTOR)
        const pickupAvailabilityDestination = window.prodify.el.querySelector(PICKUP_AVAILABILITY_SELECTOR)

        if (pickupAvailabilitySource && pickupAvailabilityDestination) {
          pickupAvailabilityDestination.replaceWith(pickupAvailabilitySource)
        }

        if (priceSource && priceTarget) {
          priceTarget.replaceWith(priceSource)
        }

       
        if (mediaSource && mediaTarget && !window.isSpanishMarket) {
          mediaTarget.replaceWith(mediaSource)
        }

        if (addButtonSource && addButtonTarget) {
          addButtonTarget.replaceWith(addButtonSource)
        }
        updatePickupButtonsVisibility()
      })
      .catch((error) => {
        console.error('Error swapping product info:', error)
      })
  } catch (error) {
    console.error('Error in swapProductInfo:', error)
  }
}


function handleSpanishVariantChange(variant: any) {
  if (!window.spanishVariantImageMapping || !variant) return

  const newImageUrl = window.spanishVariantImageMapping[String(variant.id)]
  
  if (!newImageUrl) return

  const mainImage = document.querySelector('.spanish-main-image') as HTMLImageElement
  if (mainImage) {
    mainImage.src = newImageUrl
  }

  const firstThumbnail = document.querySelector('[x-ref="thumbsWrapper"] .embla__slide:first-child img') as HTMLImageElement

  if (firstThumbnail) {
    firstThumbnail.src = newImageUrl
  }

  const zoomWrapper = document.querySelector('[x-ref="zoomWrapper"]')
  if (zoomWrapper) {
    const firstZoomImage = zoomWrapper.querySelector('.embla__slide:first-child img') as HTMLImageElement
    if (firstZoomImage) {
      firstZoomImage.src = newImageUrl
    }
  }
  
  const bisElement = document.getElementById('BIS_trigger')
  if (bisElement) {
    bisElement.setAttribute('data-variant-id', variant.id.toString())
    const shouldShow = shouldShowBISForVariant(variant)
    bisElement.style.display = shouldShow ? 'block' : 'none'
  }

  const mediaContainer = document.querySelector('[data-prodify-media-container]')
  if (mediaContainer) {
    const customEvent = new CustomEvent('spanish-image-updated', {
      detail: { variant, imageUrl: newImageUrl }
    })
    mediaContainer.dispatchEvent(customEvent)
  }
}

export {
  updateQuantity,
  swapProductInfo,
  updateVariantIdInput,
  updateDomAddButton,
  setInputAvailability,
  maybeSetOptionSelected,
  handleSpanishVariantChange
}
